// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/reports/entity/customer-statement',
        component: () =>
            import('@/pages/[organisation]/reports/entity/customer-statement.vue'),
        name: 'reports.entity.customer-statement',
        meta: {
            loginRequired: true,
            permission: 'access.reports.customer.create-customer-statement',
        },
    },
    {
        path: '/:organisation/reports/entity/vendor-statement',
        component: () =>
            import('@/pages/[organisation]/reports/entity/vendor-statement.vue'),
        name: 'reports.entity.vendor-statement',
        meta: {
            loginRequired: true,
            permission: 'access.crm.contacts.view-entities',
        },
    },
];
